import { render, staticRenderFns } from "./DataConfirmationStep.vue?vue&type=template&id=6a60ca82&scoped=true&"
import script from "./DataConfirmationStep.vue?vue&type=script&lang=js&"
export * from "./DataConfirmationStep.vue?vue&type=script&lang=js&"
import style0 from "./DataConfirmationStep.vue?vue&type=style&index=0&id=6a60ca82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60ca82",
  null
  
)

export default component.exports